import {Stack, Typography} from '@mui/material';
import Grid from '@mui/material/Grid2';
import {TelemedicineCard} from 'presentation/modules/booking/shared/ui/components/UnitCard/components/TelemedicineCard';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useTelehealthSection} from './hooks/useTelehealthSection';
import {TelehealthSectionProps} from './types';

const {telemedicine} = translations['pt-br'].commons;

export function TelehealthSection({unitCode}: TelehealthSectionProps) {
	const {handleSelectCard, isMobile, query} = useTelehealthSection(unitCode);

	return (
		<Stack>
			<Typography variant="subtitle1" color="text.secondary" sx={{mb: 1}} fontWeight={600}>
				{telemedicine}
			</Typography>
			<Grid container spacing={2}>
				<Grid size={{xs: isMobile ? 12 : 6}}>
					<TelemedicineCard onClick={handleSelectCard} query={query} />
				</Grid>
			</Grid>
		</Stack>
	);
}
